import { render, staticRenderFns } from "./SortIcons.vue?vue&type=template&id=1d7f7f56&scoped=true&"
import script from "./SortIcons.vue?vue&type=script&lang=js&"
export * from "./SortIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7f7f56",
  null
  
)

export default component.exports